(() => {
  document.documentElement.classList.add('sunco-content-js');

  const initLegacyAccordion = (root) => {
    root.querySelectorAll('.set > a').forEach((trigger) => {
      const set = trigger.closest('.set');
      if (!set) return;

      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-expanded', set.classList.contains('is-open') ? 'true' : 'false');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = set.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
    });
  };

  const initFaq = (root) => {
    const tabs = Array.from(root.querySelectorAll('[data-sunco-faq-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-sunco-faq-panel]'));
    const search = root.querySelector('[data-sunco-faq-search]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.suncoFaqTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.suncoFaqPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });

    initLegacyAccordion(root);

    root.querySelectorAll('.sub-head').forEach((trigger) => {
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('role', 'button');
      trigger.addEventListener('click', () => {
        trigger.closest('.content')?.classList.toggle('is-open');
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
    });

    if (search) {
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();

        root.querySelectorAll('.content').forEach((item) => {
          const text = item.textContent.toLowerCase();
          const hidden = query !== '' && !text.includes(query);
          item.dataset.suncoFaqHidden = hidden ? 'true' : 'false';
          if (!hidden && query !== '') {
            item.closest('.set')?.classList.add('is-open');
          }
        });

        root.querySelectorAll('.set').forEach((set) => {
          const hasVisibleChild = Array.from(set.querySelectorAll('.content')).some(
            (item) => item.dataset.suncoFaqHidden !== 'true'
          );
          set.dataset.suncoFaqHidden = query !== '' && !hasVisibleChild ? 'true' : 'false';
        });
      });
    }
  };

  const initResourceSearch = (root) => {
    const input = root.querySelector('[data-sunco-resource-search]');
    const typeFilter = root.querySelector('[data-sunco-resource-type-filter]');
    const downloadFilter = root.querySelector('[data-sunco-resource-download-filter]');
    const count = root.querySelector('[data-sunco-resource-count]');
    const rows = Array.from(root.querySelectorAll('[data-sunco-resource-row]'));
    const groups = Array.from(root.querySelectorAll('[data-sunco-resource-group]'));
    const emptyRow = root.querySelector('[data-sunco-resource-empty]');

    if (!rows.length) return;

    if (typeFilter) {
      const typeNames = Array.from(
        new Set(rows.map((row) => row.dataset.suncoResourceType || '').filter(Boolean))
      ).sort((a, b) => a.localeCompare(b));

      typeNames.forEach((typeName) => {
        const option = document.createElement('option');
        option.value = typeName.toLowerCase();
        option.textContent = typeName;
        typeFilter.append(option);
      });
    }

    const updateRows = () => {
      const query = input?.value.trim().toLowerCase() || '';
      const selectedType = typeFilter?.value || '';
      const selectedDownload = downloadFilter?.value || '';
      const hasActiveFilters = query !== '' || selectedType !== '' || selectedDownload !== '';
      let visibleRows = 0;

      rows.forEach((row) => {
        const rowType = (row.dataset.suncoResourceType || '').toLowerCase();
        const rowDownloads = ` ${row.dataset.suncoResourceDownloads || ''} `;
        const rowSearchText = (row.dataset.suncoResourceSearchText || row.textContent).toLowerCase();
        const matchesQuery = query === '' || rowSearchText.includes(query);
        const matchesType = selectedType === '' || rowType === selectedType;
        const matchesDownload = selectedDownload === '' || rowDownloads.includes(` ${selectedDownload} `);
        const isVisible = matchesQuery && matchesType && matchesDownload;

        row.hidden = !isVisible;
        if (isVisible) visibleRows += 1;
      });

      if (count) {
        count.textContent = `Showing ${visibleRows} of ${rows.length} downloadable products on this page`;
      }

      groups.forEach((group) => {
        const groupRows = rows.filter((row) => group.contains(row));
        const visibleGroupRows = groupRows.filter((row) => !row.hidden).length;
        const groupCount = group.querySelector('[data-sunco-resource-group-count]');

        group.hidden = visibleGroupRows === 0;

        if (groupCount) {
          groupCount.textContent = hasActiveFilters
            ? `${visibleGroupRows} of ${groupRows.length} products`
            : `${groupRows.length} products`;
        }

        if (hasActiveFilters) {
          group.open = visibleGroupRows > 0;
        } else {
          group.open = group.dataset.suncoResourceInitialOpen === 'true';
        }
      });

      if (emptyRow) {
        emptyRow.hidden = visibleRows > 0;
      }
    };

    input?.addEventListener('input', updateRows);
    typeFilter?.addEventListener('change', updateRows);
    downloadFilter?.addEventListener('change', updateRows);
    updateRows();
  };

  const initExtendedWarrantyForm = (form) => {
    const message = form.querySelector('[data-sunco-form-message]');
    const submit = form.querySelector('[type="submit"]');
    const endpoint = 'https://hooks.zapier.com/hooks/catch/5727789/o239bhb/';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      const body = new URLSearchParams(new FormData(form));
      if (submit) submit.disabled = true;
      if (message) message.textContent = 'Submitting...';

      try {
        await fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          body
        });

        form.reset();
        if (message) message.textContent = 'Thank you. Your extended warranty registration has been submitted.';
      } catch (error) {
        if (message) message.textContent = 'We could not submit the form. Please try again or contact support.';
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  };

  const init = () => {
    document.querySelectorAll('[data-sunco-faq]').forEach(initFaq);
    document.querySelectorAll('.sunco-resource-longform .accordion-container').forEach(initLegacyAccordion);
    document.querySelectorAll('[data-sunco-resource-table]').forEach(initResourceSearch);
    document.querySelectorAll('[data-sunco-extended-warranty-form]').forEach(initExtendedWarrantyForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
